import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/constants';
import { AuthService } from '@core/services';

@Injectable({ providedIn: 'root' })
export class PendingVerificationGuard {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.hasPendingVerification) {
      return true;
    }

    this.authService.clearPendingVerification?.();
    this.router.navigate([APP_ROUTES.BASE]);

    return false;
  }
}
